import { ChevronDownIcon, ExternalLinkIcon } from "@heroicons/react/outline";
import moment from "moment";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AverageAssessmentAnswersByProgramFragment } from "types/graphql-schema";
import { TFLocationState } from "types/topicflow";

import useLabel from "@apps/use-label/use-label";
import AppLink from "@components/link/link";
import { getUrlUsingTypename } from "@helpers/helpers";

const AverageAssessmentAnswers = ({
  averageAssessmentAnswers,
  profileId,
}: {
  averageAssessmentAnswers?: AverageAssessmentAnswersByProgramFragment[];
  profileId: number;
}) => {
  const label = useLabel();
  const location = useLocation<TFLocationState>();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      {averageAssessmentAnswers && averageAssessmentAnswers.length > 0 && (
        <div className="border py-3 px-4 rounded-lg bg-gray-50 mt-3 text-gray-500">
          <button
            className="w-full flex justify-between font-medium text-xs hover:text-gray-700 hover:underline"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span>
              {label("review", { titleCase: true })} Score{" "}
              <span className="rounded-sm bg-gray-200 px-1 py-px ml-1">
                {averageAssessmentAnswers.length}
              </span>
            </span>
            <ChevronDownIcon className="w-4 h-4 text-gray-400" />
          </button>
          {isOpen && (
            <div className="mt-4 pt-4 border-t flex flex-col gap-4">
              {averageAssessmentAnswers.map((averageAssessmentAnswer) => {
                const delivery =
                  averageAssessmentAnswer.program.assessmentDeliveries.edges[0]
                    ?.node;
                return (
                  <div
                    key={averageAssessmentAnswer.program.id}
                    className="flex justify-between items-center gap-2"
                  >
                    <div className="min-w-0 flex-1 text-gray-700 text-xs tracking-tight">
                      <div className="truncate flex flex-1 items-center min-w-0">
                        <AppLink
                          to={
                            !delivery
                              ? `/assessments/delivered?userId=${profileId}`
                              : getUrlUsingTypename(delivery, location)
                          }
                          className="min-w-0 text-gray-700 flex items-center gap-1 font-medium hover:underline"
                        >
                          <span className="truncate">
                            {averageAssessmentAnswer.program.title}
                          </span>
                          <ExternalLinkIcon className="shrink-0 text-gray-400 w-3 h-3" />
                        </AppLink>
                      </div>
                      <div className="text-gray-500 mt-0.5">
                        {moment(
                          averageAssessmentAnswer.submittedDatetime,
                        ).format("MMM D, YYYY")}
                      </div>
                    </div>
                    <div className="text-gray-400 text-sm">
                      <span className="text-gray-500">
                        {Number(averageAssessmentAnswer.averageAnswer)
                          .toFixed(1)
                          .replace(".0", "")}
                      </span>
                      /{averageAssessmentAnswer.maxRange}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AverageAssessmentAnswers;
